import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { SiteSettingsProvider } from './contexts/SiteSettingsContext';
import { ScrollManager } from './components/ScrollManager';
import { AnalyticsTracker } from './components/AnalyticsTracker';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { Home } from './pages/Home';
import { SlotDetail } from './pages/SlotDetail';
import { Providers } from './pages/Providers';
import { ProviderDetail } from './pages/ProviderDetail';
import { Contact } from './pages/Contact';
interface AppProps {
  showRealMoneyCtas?: boolean;
  rankingLayout?: 'list' | 'grid';
}
export function App({
  showRealMoneyCtas = true,
  rankingLayout = 'list'
}: AppProps) {
  return <SiteSettingsProvider value={{
    showRealMoneyCtas,
    rankingLayout
  }} data-id="element-0" data-mp="28surifc8tji1">
      <MotionConfig reducedMotion="user" data-id="element-1" data-mp="23u9u0nodldxa">
        <BrowserRouter data-id="element-2" data-mp="23t8gmcjw0fce">
          <ScrollManager data-id="element-3" data-mp="3ik7g4ghnibqn" />
          <AnalyticsTracker data-id="element-4" data-mp="3iiwdijzxza14" />
          <div className="flex min-h-screen w-full flex-col bg-paper text-ink" data-id="element-5" data-mp="3ijpbavgxap74">
            <SiteHeader data-id="element-6" data-mp="3mk868ye44bdj" />
            <div className="flex-1" data-id="element-7" data-mp="3mjg9vlcoy9m7">
              <Routes data-id="element-8" data-mp="3rcj2nr9n9f1c">
                <Route path="/" element={<Home data-id="element-10" data-mp="3rcsuzli5vya7" />} data-id="element-9" data-mp="3rdas0kcnegj6" />
                <Route path="/slots/:slug" element={<SlotDetail data-id="element-12" data-mp="680tswt8a8y" />} data-id="element-11" data-mp="3relwynhtxubv" />
                <Route path="/providers" element={<Providers data-id="element-14" data-mp="2zl3azit8d249" />} data-id="element-13" data-mp="5gbgztt38r4" />
                <Route path="/providers/:slug" element={<ProviderDetail data-id="element-16" data-mp="2zmwh8wzxlkbq" />} data-id="element-15" data-mp="2zlv8iz6e19x6" />
                <Route path="/contact" element={<Contact data-id="element-18" data-mp="33nq9g2keplaf" />} data-id="element-17" data-mp="33mf0loc3tncg" />
                <Route path="*" element={<Home data-id="element-20" data-mp="38lrqkhy9vaj9" />} data-id="element-19" data-mp="33ori60dy9voz" />
              </Routes>
            </div>
            <SiteFooter data-id="element-21" data-mp="38kgk2adfzoog" />
          </div>
        </BrowserRouter>
      </MotionConfig>
    </SiteSettingsProvider>;
}